import { RouterModule, Routes,ExtraOptions} from '@angular/router';
import { NgModule } from '@angular/core';

import { LoginComponent } from './login/login.component';
import { PagesComponent } from './pages/pages.component';
import { DashboardComponent } from './dashboard/dashboard.component';

import { CompanyProfileComponent} from './master-files/company-profile/company-profile.component';
import { AddSupplierComponent} from './master-files/supplier-master/add-supplier/add-supplier.component';
import { ViewSupplierComponent } from './master-files/supplier-master/view-supplier/view-supplier.component';
import { AddCustomerComponent} from './master-files/customer-master/add-customer/add-customer.component';
import { ViewCustomersComponent} from './master-files/customer-master/view-customers/view-customers.component';
import { EmployeeComponent } from './master-files/employee-master/employee/employee.component';
import { EmployeeListComponent } from './master-files/employee-master/employee-list/employee-list.component';
import { FixedAssetComponent } from './master-files/fixed-asset/fixed-asset/fixed-asset.component';
import { FixedAssetListComponent } from './master-files/fixed-asset/fixed-asset-list/fixed-asset-list.component';
import { RoomDetailsComponent } from './master-files/room-details/room-details/room-details.component';
import { RoomDetailsListComponent } from './master-files/room-details/room-details-list/room-details-list.component';
import { VehicleRegisterComponent } from './master-files/vehicle-register/vehicle-register/vehicle-register.component';
import { VehicleRegisterListComponent } from './master-files/vehicle-register/vehicle-register-list/vehicle-register-list.component';

import { ItemCategoryComponent } from './products/item-category/item-category.component';
import { ItemComponent } from './products/item-master/item/item.component';
import { ItemListComponent } from './products/item-master/item-list/item-list.component';


import { PurchaseOrderListComponent } from './purchase/purchase-order/purchase-order-list/purchase-order-list.component';
import { PurchaseOrderComponent } from './purchase/purchase-order/purchase-order/purchase-order.component';
import { PurchaseInvoiceListComponent } from './purchase/purchase-invoice/purchase-invoice-list/purchase-invoice-list.component';
import { PurchaseInvoiceComponent } from './purchase/purchase-invoice/purchase-invoice/purchase-invoice.component';
import { PaymentListComponent } from './purchase/payment/payment-list/payment-list.component';
import { PurchaseReturnComponent } from './purchase/purchase-return/purchase-return/purchase-return.component';
import { PurchaseReturnListComponent } from './purchase/purchase-return/purchase-return-list/purchase-return-list.component';
import { PaymentComponent } from './purchase/payment/payment/payment.component';

import { BarInvoiceComponent } from './sale/bar-invoice/bar-invoice/bar-invoice.component';
import { BarInvoiceListComponent } from './sale/bar-invoice/bar-invoice-list/bar-invoice-list.component';
import { QuotationComponent} from './sale/quotation/quotation/quotation.component';
import { QuotationListComponent} from './sale/quotation/quotation-list/quotation-list.component';
import { AddInvoiceComponent} from './sale/invoice/add-invoice/add-invoice.component';
import { InvoiceListComponent} from './sale/invoice/invoice-list/invoice-list.component';
import { ReceiptComponent} from './sale/receipt/receipt/receipt.component';
import { ReceiptListComponent} from './sale/receipt/receipt-list/receipt-list.component';

import { ExpenseComponent } from './expenses/expense/expense/expense.component';
import { ExpenseListComponent } from './expenses/expense/expense-list/expense-list.component';
import { BankAccountListComponent } from './banks/bank-accounts/bank-account-list/bank-account-list.component';
import { ChequeListComponent } from './banks/cheques/cheque-list.component';
import { CashBankEntryListComponent } from './banks/cash-bank-entry/cash-bank-entry-list/cash-bank-entry-list.component';
import { CashFlowComponent } from './banks/cash-flow/cash-flow.component';
import { UserListComponent } from './users/users/user-list.component';
import { UsersComponent } from './users/users/users.component';
import { UserTypesComponent } from './users/user-types/user-types.component';
import { UserPermissionComponent } from './users/user-permission/user-permission.component';
import { SettingsComponent } from './settings/settings/settings.component';

import { BackupComponent } from './backup/backup.component';

import { ResetPasswordComponent } from './users/reset-password/reset-password/reset-password.component';
import { ResetPasswordListComponent } from './users/reset-password/reset-password-list/reset-password-list.component';
import { ResetPasswordRequestComponent } from './users/reset-password-request/reset-password-request.component';
import { ChangePasswordComponent } from './settings/change-password/change-password.component';

import { SolarPowerComponent } from './administration/solor-power/solar-power/solar-power.component';
import { SolarPowerListComponent } from './administration/solor-power/solar-power-list/solar-power-list.component';
import { WaterMeterComponent } from './administration/water-meter/water-meter/water-meter.component';
import { WaterMeterListComponent } from './administration/water-meter/water-meter-list/water-meter-list.component';
import { BikeRentComponent } from './administration/bike-rent/bike-rent/bike-rent.component';
import { BikeRentListComponent } from './administration/bike-rent/bike-rent-list/bike-rent-list.component';
import { GeneratorUsageComponent } from './administration/generator-usage/generator-usage/generator-usage.component';
import { GeneratorUsageListComponent } from './administration/generator-usage/generator-usage-list/generator-usage-list.component';
import { WaterTankComponent } from './administration/water-tank/water-tank/water-tank.component';
import { WaterTankListComponent } from './administration/water-tank/water-tank-list/water-tank-list.component';

import { DrawChequeComponent } from './banks/draw-cheque/draw-cheque/draw-cheque.component';
import { DrawChequeListComponent } from './banks/draw-cheque/draw-cheque-list/draw-cheque-list.component';
import { GuestPurchaseListComponent } from './sale/guest-purchase/guest-purchase-list/guest-purchase-list.component';

import { KitchenStockComponent } from './kitchen-stocks/kitchen-stocks/kitchen-stock/kitchen-stock.component';
import { KitchenStockListComponent } from './kitchen-stocks/kitchen-stocks/kitchen-stock-list/kitchen-stock-list.component';
import { AddStockComponent } from './kitchen-stocks/add-stock/add-stock/add-stock.component';
import { AddStockListComponent } from './kitchen-stocks/add-stock/add-stock-list/add-stock-list.component';
import { ConsumtionComponent } from './kitchen-stocks/consumption/consumtion/consumtion.component';
import { ConsumtionListComponent } from './kitchen-stocks/consumption/consumtion-list/consumtion-list.component';
import { KitchenStockBalComponent } from './kitchen-stocks/kitchen-stock-bal/kitchen-stock-bal.component';
import { StockRequirementComponent } from './kitchen-stocks/stock-requirements/stock-requirement/stock-requirement.component';
import { StockRequirementListComponent } from './kitchen-stocks/stock-requirements/stock-requirement-list/stock-requirement-list.component';
import { AddStockRequirementComponent } from './kitchen-stocks/stock-requirements/add-stock-requirement/add-stock-requirement.component';

//Reports
import { ExpensesAnalysisReportComponent } from './reports/expenses-analysis-report/expenses-analysis-report.component';
import { IncomeStatementComponent } from './reports/income-statement/income-statement.component';
import { SalesReportComponent } from './reports/sales-report/sales-report.component';
import { InventoryBalanceReportComponent } from './reports/inventory-balance-report/inventory-balance-report.component';
import { SupplierOutstandingReportComponent } from './reports/supplier-outstanding-report/supplier-outstanding-report.component';
import { CustomerOutstandingReportComponent } from './reports/customer-outstanding-report/customer-outstanding-report.component';
import { PurchaseReportComponent } from './reports/purchase-report/purchase-report.component';
import { ItemSalesReportComponent } from './reports/item-sales-report/item-sales-report.component';
import { ServiceChargeReportComponent } from './reports/service-charge-report/service-charge-report.component';
import { ConsumptionReportComponent } from './reports/consumption-report/consumption-report.component';
import { FixedAssetReportComponent } from './reports/fixed-asset-report/fixed-asset-report.component';

 import { AuthGuard } from './shared/guards/auth.guard';



const routes: Routes = [
{ path: '', redirectTo: '/login', pathMatch:'full'},
{ path: 'login',component: LoginComponent},
{ path: 'reset-password-request',component: ResetPasswordRequestComponent},
{ path: 'reset-password',component: ResetPasswordComponent,
  canActivate : [AuthGuard]
},
{ path: 'change-password',component: ChangePasswordComponent,
  canActivate : [AuthGuard]
},
  
{
  path: 'pages',
  component: PagesComponent,
  children: [   
   { path: 'dashboard',component: DashboardComponent,
     canActivate : [AuthGuard]
   },
   { path: 'master-files/company-profile',component: CompanyProfileComponent,
     canActivate : [AuthGuard]
   },
   { path: 'master-files/supplier',component: AddSupplierComponent,
     canActivate : [AuthGuard]
   },
   { path: 'master-files/supplier-list',component: ViewSupplierComponent,
     canActivate : [AuthGuard]
   },

   { path: 'master-files/customer',component: AddCustomerComponent,
     canActivate : [AuthGuard]
   },
   { path: 'master-files/customer/:cusId',component: AddCustomerComponent,
     canActivate : [AuthGuard]
   },
   { path: 'master-files/customer-list',component: ViewCustomersComponent,
     canActivate : [AuthGuard]
   },

   { path: 'master-files/employee',component: EmployeeComponent,
     canActivate : [AuthGuard]
   },
   { path: 'master-files/employee-list',component: EmployeeListComponent,
     canActivate : [AuthGuard]
   },
   { path: 'master-files/room-details',component: RoomDetailsComponent,
     canActivate : [AuthGuard]
   }, 
   { path: 'master-files/room-details-list',component: RoomDetailsListComponent,
     canActivate : [AuthGuard]
   }, 
   { path: 'master-files/fixed-asset',component: FixedAssetComponent,
     canActivate : [AuthGuard]
   }, 
   { path: 'master-files/fixed-asset-list',component: FixedAssetListComponent,
     canActivate : [AuthGuard]
   },  
   { path: 'master-files/vehicle-register',component: VehicleRegisterComponent,
     canActivate : [AuthGuard]
   }, 
   { path: 'master-files/vehicle-register-list',component: VehicleRegisterListComponent,
     canActivate : [AuthGuard]
   },  
   { path: 'products/item',component: ItemComponent,
     canActivate : [AuthGuard]
   },
   { path: 'products/item-list',component: ItemListComponent,
     canActivate : [AuthGuard]
   },
   { path: 'products/item-category',component: ItemCategoryComponent,
     canActivate : [AuthGuard]
   },
   { path: 'kitchen-stocks/kitchen-stock',component: KitchenStockComponent,
     canActivate : [AuthGuard]
   },
   { path: 'kitchen-stocks/kitchen-stock-list',component: KitchenStockListComponent,
     canActivate : [AuthGuard]
   },
   { path: 'kitchen-stocks/add-stock',component: AddStockComponent,
    canActivate : [AuthGuard]
   },
  { path: 'kitchen-stocks/add-stock-list',component: AddStockListComponent,
      canActivate : [AuthGuard]
  },
  { path: 'kitchen-stocks/consumption',component: ConsumtionComponent,
    canActivate : [AuthGuard]
    },
   { path: 'kitchen-stocks/consumption-list',component: ConsumtionListComponent,
    canActivate : [AuthGuard]
   },
   { path: 'kitchen-stocks/kitchen-stock-bal',component: KitchenStockBalComponent,
   canActivate : [AuthGuard]
  },
  { path: 'kitchen-stocks/add-stock-requirement',component: AddStockRequirementComponent,
    canActivate : [AuthGuard]
  },
   { path: 'kitchen-stocks/stock-requirement',component: StockRequirementComponent,
    canActivate : [AuthGuard]
   },
   { path: 'kitchen-stocks/stock-requirement-list',component: StockRequirementListComponent,
    canActivate : [AuthGuard]
   },
   { path: 'administration/solar-power',component: SolarPowerComponent,
     canActivate : [AuthGuard]
   },
   { path: 'administration/solar-power-list',component: SolarPowerListComponent,
    canActivate : [AuthGuard]
   },
   { path: 'administration/water-meter',component: WaterMeterComponent,
   canActivate : [AuthGuard]
   },
   { path: 'administration/water-meter-list',component: WaterMeterListComponent,
   canActivate : [AuthGuard]
   },
   { path: 'administration/bike-rent',component: BikeRentComponent,
   canActivate : [AuthGuard]
   },
   { path: 'administration/bike-rent-list',component: BikeRentListComponent,
   canActivate : [AuthGuard]
   },
   { path: 'administration/generator-usage',component: GeneratorUsageComponent,
   canActivate : [AuthGuard]
   },
   { path: 'administration/generator-usage-list',component: GeneratorUsageListComponent,
   canActivate : [AuthGuard]
   },
   { path: 'administration/water-tank-list',component: WaterTankListComponent,
    canActivate : [AuthGuard]
   },
  
   { path: 'purchase/purchase-order',component: PurchaseOrderComponent,
   canActivate : [AuthGuard]
   },
   { path: 'purchase/purchase-order-list',component: PurchaseOrderListComponent,
   canActivate : [AuthGuard]
   },
   { path: 'purchase/purchase-invoice',component: PurchaseInvoiceComponent,
   canActivate : [AuthGuard]
   },
   { path: 'purchase/purchase-invoice-list',component: PurchaseInvoiceListComponent,
   canActivate : [AuthGuard]
   },     
   { path: 'purchase/purchase-return',component: PurchaseReturnComponent,
   canActivate : [AuthGuard]
   },
   { path: 'purchase/purchase-return-list',component: PurchaseReturnListComponent,
   canActivate : [AuthGuard]
   },
   { path: 'purchase/payment',component: PaymentComponent,
   canActivate : [AuthGuard]
   },
   { path: 'purchase/payment-list',component: PaymentListComponent,
   canActivate : [AuthGuard]
   },
   { path: 'customer/bar-invoice',component: BarInvoiceComponent,
   canActivate : [AuthGuard]
   },
   { path: 'customer/bar-invoice-list',component: BarInvoiceListComponent,
   canActivate : [AuthGuard]
   },
   { path: 'customer/quotation',component: QuotationComponent,
   canActivate : [AuthGuard]
   },
   { path: 'customer/quotation-list',component: QuotationListComponent,
   canActivate : [AuthGuard]
   },  
   { path: 'customer/guest-purchase-list',component: GuestPurchaseListComponent,
   canActivate : [AuthGuard]
  },  
   { path: 'customer/invoice',component: AddInvoiceComponent,
     canActivate : [AuthGuard]
   },
   { path: 'customer/invoice-list',component: InvoiceListComponent,
     canActivate : [AuthGuard]
   }, 
   { path: 'customer/receipt',component: ReceiptComponent,
   canActivate : [AuthGuard]
   },
   { path: 'customer/receipt-list',component: ReceiptListComponent,
   canActivate : [AuthGuard]
   }, 
  
   { path: 'expenses/expense',component: ExpenseComponent,
   canActivate : [AuthGuard]
   },
   { path: 'expenses/expense-list',component: ExpenseListComponent,
   canActivate : [AuthGuard]
   }, 
   { path: 'cash&banks/manage-accounts',component: BankAccountListComponent,
   canActivate : [AuthGuard]
   },
   { path: 'cash&banks/cash&bank-entry-list',component: CashBankEntryListComponent,
   canActivate : [AuthGuard]
   },
   { path: 'cash&banks/draw-cheque',component: DrawChequeComponent,
   canActivate : [AuthGuard]
   },
   { path: 'cash&banks/draw-cheque-list',component: DrawChequeListComponent,
   canActivate : [AuthGuard]
   },
   { path: 'cash&banks/cheque-list',component: ChequeListComponent,
   canActivate : [AuthGuard]
   },
   { path: 'cash&banks/cash-flow-statement',component: CashFlowComponent,
   canActivate : [AuthGuard]
   },
   { path: 'user-management/user',component: UsersComponent,
     canActivate : [AuthGuard]
   },
   { path: 'user-management/user-list',component: UserListComponent,
     canActivate : [AuthGuard]
   },
   { path: 'user-management/user-types',component: UserTypesComponent,
   canActivate : [AuthGuard]
   },
   { path: 'user-management/user-permission',component: UserPermissionComponent,
   canActivate : [AuthGuard]
   },
   { path: 'user-management/reset-password-request-list',component: ResetPasswordListComponent,
    canActivate : [AuthGuard]
   },
   { path: 'reports/customer-outstanding-report',component: CustomerOutstandingReportComponent,
   canActivate : [AuthGuard]
   },
   { path: 'reports/supplier-outstanding-report',component: SupplierOutstandingReportComponent,
   canActivate : [AuthGuard]
   },
   { path: 'reports/inventory-balance',component: InventoryBalanceReportComponent,
   canActivate : [AuthGuard]
   },
   { path: 'reports/purchase-report',component: PurchaseReportComponent,
    canActivate : [AuthGuard]
   },
   { path: 'reports/sales-report',component: SalesReportComponent,
    canActivate : [AuthGuard]
   },
   { path: 'reports/bar-sales-report',component: ItemSalesReportComponent,
     canActivate : [AuthGuard]
   },
   { path: 'reports/item-sales-report',component: ServiceChargeReportComponent,
   canActivate : [AuthGuard]
   },
   { path: 'reports/expense-report',component: ExpensesAnalysisReportComponent,
   canActivate : [AuthGuard]
   },
   { path: 'reports/consumption-report',component: ConsumptionReportComponent,
   canActivate : [AuthGuard]
   },
   { path: 'reports/fixed-asset-report',component: FixedAssetReportComponent,
     canActivate : [AuthGuard]
   },
   { path: 'reports/profit-and-loss-statement',component: IncomeStatementComponent,
      canActivate : [AuthGuard]
   },
 
   { path: 'settings',component: SettingsComponent,
   canActivate : [AuthGuard]
   },
   { path: 'backup',component: BackupComponent,
     canActivate : [AuthGuard]
   },

    //  { path: '',  redirectTo: 'dashboard',  pathMatch: 'full'},
               
  ],
},

{ path: '**',redirectTo: '/login', pathMatch:'full'}

];
const config: ExtraOptions = {
  useHash: false,
};

@NgModule({
  imports: [RouterModule.forRoot(routes, config)],
  exports: [RouterModule],
})
export class AppRoutingModule {
}
